<template>
  <div id="app">
    <template>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </template>
    <!-- 登录弹框 -->
    <Login />
    <!-- 错误弹框 -->
    <ErrorModal />
  </div>
</template>
<script>
import Login from "./views/login.vue";
import ErrorModal from "@/components/ErrModal/index.vue";
// import VConsole from "vconsole";

export default {
  components: {
    Login,
    ErrorModal,
  },
  data() {
    return {
      isInit: false,
    };
  },
  watch: {
    $route: function (to) {
      if (to.path && !this.isInit) {
        this.initLanguage();
        this.isInit = true;
      }
    },
  },
  created() {},
  mounted() {
    // let _this = this;
    // window.addEventListener(
    //   'onorientationchange' in window ? 'orientationchange' : 'resize',
    //   function () {
    //     if (window.orientation === 90 || window.orientation === -90) {
    //       _this.$toast('app.tipMsg');
    //     }
    //   },
    //   false
    // );
    // if (window.orientation === 90 || window.orientation === -90) {
    //   _this.$toast('app.tipMsg');
    // }
  },
  methods: {
    initLanguage() {
      const queryLang = this.$route.query && this.$route.query.lang;
      const queryGameId =
        this.$route.query &&
        (this.$route.query.game_id || this.$route.query.gid);
      const querySource = this.$route.query.source;
      const langList = ["zh", "en", "tc", "ja", "ko"];
      let lang = "";

      if (!queryLang && queryGameId && Number(queryGameId) === 2277) {
        // 二重螺旋特殊逻辑
        lang = "zh";
        // new VConsole();
      } else {
        // 兼容有两个lang参数的情况
        // 先设置默认语言，再进行国际化
        if (queryLang) {
          if (Array.isArray(queryLang)) {
            lang = queryLang[0].toLowerCase();
          } else {
            lang = queryLang.toLowerCase();
          }
          // 兼容别的zh
          if (lang.indexOf("zh") !== -1) {
            if (
              lang === "zh_hant" ||
              lang === "zh-hk" ||
              lang === "zh_tw" ||
              lang === "zh-mo" ||
              lang === "zh-sg"
            ) {
              lang = "tc";
            } else {
              lang = "zh";
            }
          } else {
            // 其他语言只要前两位
            lang = lang.substring(0, 2);
          }
        } else {
          lang = localStorage.getItem("lang");
        }

        if (!lang) {
          lang = navigator.language || navigator.userLanguage || "zh";
          lang = lang.substring(0, 2);
          if (langList.indexOf(lang) === -1) {
            lang = "en";
          }
        }

        if (langList.indexOf(lang) === -1) {
          lang = "en";
        }

        // 最后只要前两位
        lang = lang.substring(0, 2);
      }
      // 处理source参数
      if (querySource) {
        sessionStorage.setItem("kf_source", querySource);
      }

      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;

      // 处理sdk视频问题
      const isHideVideo = this.$route.query && this.$route.query.is_hide_v;
      if (isHideVideo) {
        sessionStorage.setItem("is_hide_v", true);
      }
    },
  },
};
</script>
<style>
@import "//at.alicdn.com/t/font_2243115_s37n9tetevs.css";
[class^="kf-"],
[class^=" kf-icon-"] {
  font-family: "iconfont", serif !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
#app {
  width: 100%;
  height: 100%;
}
</style>
